module.exports = __webpack_public_path__ + "static/media/MyriadPro-Semibold.b20ac5b9.svg";